/* Tabu Home - Sepet hediye urunleri | Minimog 6.x
   Bu dosya mevcut cart.js'i degistirmez.
   Gift indirimi Shopify otomatik indirimleri tarafindan hesaplanir.
*/
(() => {
  if (window.__tabuCartGiftsInitialized) return;
  window.__tabuCartGiftsInitialized = true;

  const BUTTON_SELECTOR = '[data-tabu-gift-add]';
  let isAddingGift = false;

  const getRoot = () => window.Shopify?.routes?.root || '/';

  function showError(container, message) {
    if (!container || !container.isConnected) {
      window.alert(message);
      return;
    }
    let notice = container.querySelector('[data-tabu-gift-error]');
    if (!notice) {
      notice = document.createElement('p');
      notice.setAttribute('data-tabu-gift-error', '');
      notice.setAttribute('role', 'alert');
      notice.style.cssText = 'color:#b42318;font-size:13px;margin:8px 0;line-height:1.4';
      const intro = container.querySelector('.tabu-cart-gifts__intro');
      if (intro) intro.insertAdjacentElement('afterend', notice);
      else container.prepend(notice);
    }
    notice.textContent = message;
  }

  document.addEventListener('click', async (event) => {
    const button = event.target.closest(BUTTON_SELECTOR);
    if (!button) return;
    event.preventDefault();

    // Sepete ekleme surerken ikinci tiklamayi engelle.
    if (isAddingGift || button.disabled) return;

    const container = button.closest('[data-tabu-cart-gifts]');
    const kind = button.dataset.giftKind;
    const variantId = Number(button.dataset.variantId);
    if (!container || !['tek', 'cift'].includes(kind) || !Number.isSafeInteger(variantId) || variantId <= 0) {
      showError(container, 'Hediye urunu bulunamadi. Sayfayi yenileyip tekrar dene.');
      return;
    }

    const isSingle = kind === 'tek';
    const eligible = Number(isSingle ? container.dataset.singleEligible : container.dataset.doubleEligible);
    const added = Number(isSingle ? container.dataset.singleAdded : container.dataset.doubleAdded);
    if (!Number.isFinite(eligible) || !Number.isFinite(added) || added >= eligible) {
      showError(container, 'Bu hediye grubu icin kalan hakkin bulunmuyor.');
      return;
    }

    isAddingGift = true;
    const allButtons = [...container.querySelectorAll(BUTTON_SELECTOR)];
    const previousDisabled = allButtons.map((el) => el.disabled);
    const originalText = button.textContent;
    allButtons.forEach((el) => { el.disabled = true; });
    button.textContent = 'Ekleniyor...';

    try {
      const response = await fetch(`${getRoot()}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      });

      const result = await response.json();
      if (!response.ok || result.status >= 400) {
        throw new Error(result.description || result.message || 'Urun sepete eklenemedi.');
      }

      // Minimog'un kendi mekanizmasi: sepet govdesi, fiyat, footer ve ikon adedi.
      const cartItems = document.querySelector('#MinimogCartDrawerBody');
      if (cartItems && typeof cartItems.onCartRefresh === 'function') {
        await cartItems.onCartRefresh({ detail: { open: false } });
      } else {
        // Tema farkli bir sepet bileseni kullaniyorsa mevcut event'e don.
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: false } }));
        return;
      }

      // Ekleme gerceklesti ama tema yenilemesi basarisizsa eski hakki gostermeyelim.
      const refreshed = document.querySelector('#MinimogCartDrawerBody [data-tabu-cart-gifts]');
      const refreshedAdded = Number(isSingle ? refreshed?.dataset.singleAdded : refreshed?.dataset.doubleAdded);
      if (!refreshed || !Number.isFinite(refreshedAdded) || refreshedAdded <= added) {
        window.location.reload();
      }
    } catch (error) {
      console.error('Tabu hediye ekleme hatasi:', error);
      showError(container, 'Hediye eklenemedi: ' + (error.message || 'Lutfen tekrar dene.'));
    } finally {
      isAddingGift = false;
      allButtons.forEach((el, index) => {
        if (el.isConnected) el.disabled = previousDisabled[index];
      });
      if (button.isConnected) button.textContent = originalText;
    }
  });
})();